//import { CcfCopilotActions } from './ccf-agent-copilot-container.slice';
// import { updateFileToBeUploaded } from '../ccf-assignment-panel/ccf-assignment-panel.slice';
// import { globalActions } from '../global.app.slice';
// import { Navigation } from '../../enums/navigation-menus';
// import { sendCopilotReply } from './ccf-agent-copilot-middleware';
import { Dispatch, AnyAction } from '@reduxjs/toolkit';
import {
  updateAdaptiveCardSchema,
  updateIsBestResponseInserted,
  updateIsBestResponseSent,
  updateSentBestResponse,
  setAgentSearchTopic,
  removeConversationAssistanceItem,
  updateIsJourneySummaryExpanded,
  isFeedbackSaved,
} from './ccf-copilot-chat/+state/ccf-live-copilot.slice';
import { updateTwitterAgentReply } from '../../ccf-inbox/ccf-inbox.slice';
import { generateEmail } from './ccf-copilot-api';
import { copilotActionIcons } from './ccf-copilot-icons';

/**
 * This is enum for adaptive card types
 */
export enum AdaptiveCardType {
  /**
   * The card type for textblock
   */
  TEXTBLOCK = 'TextBlock',
  /**
   * The card type for container
   */
  CONTAINER = 'Container',
  /**
   * The card type for columnset
   */
  COLUMNSET = 'ColumnSet',
  /**
   * The card type for column
   */
  COLUMN = 'Column',
  /**
   * The card type for image
   */
  IMAGE = 'Image',
  /**
   * The card type for icons
   */
  ICONS = 'Icons',
  /**
   * The card type for TOGGLE INPUT
   */
  INPUT_TOGGLE = 'Input.Toggle',
}

/**
 * This is enum for actions in adaptive cards
 */
export enum CardActions {
  /**
   * The action type for expand image
   */
  EXPAND_IMAGE = 'expandImage',
  /**
   * The action type for insert image
   */
  INSERT_IMAGE = 'insertImage',
  /**
   * The action type for send image
   */
  SEND_IMAGE = 'sendImage',
  /**
   * The action type for insert article
   */
  INSERT_ARTICLE = 'insertArticle',
  /**
   * The action type for send article
   */
  SEND_ARTICLE = 'sendArticle',
  /**
   * The action type for insert link
   */
  INSERT_LINK = 'insertLink',
  /**
   * The action type for send link
   */
  SEND_LINK = 'sendLink',
  /**
   * The action type for open image container
   */
  OPEN_IMAGES_CONTAINER = 'openImagesContainer',
  /**
   * The action type for open web container
   */
  OPEN_LINKS_CONTAINER = 'openWebLinksContainer',
  /**
   * The action type for open process steps container
   */
  OPEN_PROCESS_STEPS_CONTAINER = 'openProcessStepsContainer',
  /**
   * The action type for open feedback topics container
   */
  OPEN_FEEDBACK_TOPICS_CONTAINER = 'openFeedbackTopicsContainer',
  /**
   * The action type for open internal use container
   */
  OPEN_INTERNAL_USE_CONTAINER = 'openInternalUseContainer',
  /**
   * The action type for insert steps
   */
  INSERT_STEPS = 'insertSteps',
  /**
   * The action type for send steps
   */
  SEND_STEPS = 'sendSteps',
  /**
   * The action type for insert step
   */
  INSERT_STEP = 'insertStep',
  /**
   * The action type for send step
   */
  SEND_STEP = 'sendStep',
  /**
   * The action type for insert Compliance
   */
  INSERT_COMPLIANCE = 'insertCompliance',

  /**
   * The action type for send Compliance
   */
  SEND_COMPLIANCE = 'sendCompliance',
  /**
   * The action type for search topic
   */
  SEARCH_TOPIC = 'searchTopic',
  /**
   * The action type for remove topic
   */
  REMOVE_TOPIC = 'removeTopic',
  /**
   * The action type for send Sales Offers
   */
  INSERT_SALESOFFERS = 'insertSalesOffers',
  /**
   * The action type for send Sales Offers
   */
  SEND_SALESOFFERS = 'sendSalesOffers',
  /**
   * The action type for generate email response
   */
  GENERATE_EMAIL_RESPONSE = 'generateEmailResponse',
  /**
   * The action type for handling intents
   */
  HANDLE_INTENTS = 'handleIntents',
  /**
   * The action type for send Sales Offers
   */
  EXPAND_SUMMARY = 'expandSummary',
  /**
   * The action type for send bot assistance question
   */
  SEND_QUESTION = 'sendQuestion',
  /**
   * The action type for submit intent
   */
  SUBMIT_INTENTS = 'submitIntents',
  /**
   * The action type for open workflow card
   */
  OPEN_WORKFLOW_CONTAINER = 'openWorkflowCard',
  /**
   * The action type for like article
   */
  LIKE_TOPIC = 'likeTopic',
  /**
   * The action type for dislike article
   */
  DISLIKE_TOPIC = 'dislikeTopic',
  /**
   * The action type to save feedback
   */
  SAVE_FEEDBACK = 'saveFeedback',
  /**
   * The action type for generate email
   */
  GENERATE_EMAIL = 'generateEmail',
  /**
   * The action type for add new topics
   */
  ADD_NEW_TOPICS = 'addNewTopics',
  /**
   * The action type for clear text
   */
  CLEAR_TEXT = 'clearText',
  /**
   * The action type for like
   */
  LIKE = 'likeArticle',
  /**
   * The action type for dislike
   */
  DISLIKE = 'dislikeArticle',
}

/**
 * This is enum for container id in adaptive card
 */
export enum ContainerId {
  /**
   * The container id type for web links
   */
  WEB_CONTAINER = 'webLinksContainer',
  /**
   * The container id type for image conatiner
   */
  IMAGES_CONTAINER = 'imagesContainer',
  /**
   * The container id type for process tseps
   */
  PROCESS_STEPS_CONTAINER = 'processStepsContainer',
  /**
   * The container id type for internal use container
   */
  INTERNAL_USE_CONTAINER = 'internalUseContainer',
  /**
   * The container id type for kb answers
   */
  KB_ANSWERS = 'kbAnswers',
  /**
   * The container id type for kb links
   */
  KB_LINKS = 'kbLinks',
  /**
   * The container id type for kb images
   */
  KB_IMAGES = 'kbImages',
  /**
   * The container id type for kb process steps
   */
  KB_PROCESS_STEPS = 'kbProcessSteps',
  /**
   * The container id type for kb internal use
   */
  KB_INTERNAL_USE = 'kbInternalUse',
  /**
   * The container id type for kb compliance
   */
  COMPLIANCE_CARDS = 'compliance',
  /**
   * The container id type for kb conversationAssistance
   */
  CONVERSATION_ASSISTANCE = 'conversationAssistance',
  /**
   * The container id type for sales offer
   */
  SALES_OFFERS = 'salesOffersContainer',
  /**
   * The container id type for intentAndAssistance
   */
  INTENT_ASSISTANCE = 'intentAndAssistance',
  /**
   * The container id type for journey summary
   */
  JOURNEY_SUMMARY = 'journeySummary',
  /**
   * The container id type for botAssistanceQuestionsContainer
   */
  BOT_ASSISTANCE_QUESTIONS_CONTAINER = 'botAssistanceQuestionsContainer',
  /**
   * The container id type for workflowQuestionsContainer
   */
  WORKFLOW_QUESTIONS_CONTAINER = 'workflowQuestionsContainer',
  /**
   * The container id type for workflowButtonsContainer
   */
  WORKFLOW_BUTTONS_CONTAINER = 'workflowButtonsContainer',
  /**
   *  The container id type for journeySummaryMain
   */
  JOURNEY_SUMMARY_CONTAINER = 'journeySummaryMain',
  /**
   *  The container id type for comments in feedback
   */
  FEEDBACK_COMMENTS_CONTAINER_LIKE = 'commentsContainerForLike',
  /**
   *  The container id type for comments in feedback
   */
  FEEDBACK_COMMENTS_CONTAINER_DISLIKE = 'commentsContainerForDislike',
  /**
   *  The container id type for comments in feedback
   * 
   */
  EMAIL_RESPONSE_GENERATED = 'emailResponseGeneratedContainer',
  /***
   */
  GENERATE_EMAIL_RESPONSE = 'generateEmailResponse',
  /**
   * The container id for email generating container
   */
  REPLY_GENERATING_CONTAINER = 'replyGeneratingContainer',
  /**
   * The container id for showing the topic container
   */
  SHOW_TOPIC_CONTAINER = 'showTopicContainer',
  /**
   * The container id for adding a topic action container
   */
  ADD_TOPIC_ACTION_CONTAINER = 'addTopicActionContainer',
  /**
   * The container id for set of response topics
   */
  RESPONSE_OPTION_CONTAINER = 'responseOptionsContainer',
  /**
   * The container id for add topics button
   */
  TOPIC_CONTAINER = 'topicContainer',
  /**
   * The container id for error message container
   */
  ERROR_MESSAGE_CONTAINER = 'errorMessageContainer',
  /**
   * The container id for initial container
   */
  INITIAL_CONTAINER = 'initialContainer',
  /**
   * The container ID for custom options.
   */
  CUSTOM_OPTION_CONTAINER = 'customOption',
}

/**
 * This is type for actions in adaptive card
 */
export type ActionMetaData = {
  /**
   * The type for data in actions
   */
  data: {
    /**
     * The name of action
     */
    name: string;
    /**
     * The url for image to be replaced
     */
    newImageUrl?: string;
    /**
     * The index of action
     */
    index?: string;
    /**
     * The link of action
     */
    link?: string;
    /**
     * The flag for visibility of container
     */
    isVisible?: boolean;
    /**
     * The text of bot assist question
     */
    text?: string;

    /**
     * The choices of bot assist question
     */
    choices?: Array<any>;
    /**
     * The topic for conversation topics
     */
    topic?: string;
    /**
     * The topic for conversation topics
     */
    buttonAction?: string;
    /**
     * An email topics with their IDs and content.
     */
    emailTopics?: { topicId: string; content: string }[];
    /**
     * A custom option for the email topics.
     */
    customOption?: string;
    /**
     * The first custom topic.
     */
    customTopics0?: string;
    /**
     * The second custom topic.
     */
    customTopics1?: string;
    /**
     * The third custom topic.
     */
    customTopics2?: string;
    /**
     * The ID of the text input.
     */
    textInputId: string;
    /**
     * The value of the text input.
     */
    value?: string;
  };
};

/**
 * This is interface for image object in adaptive card
 */
export interface AdaptiveCardImageObject {
  /**
   * The type of image object
   */
  type: string;
  /**
   * The url of image
   */
  url?: string;
  /**
   * The height of image
   */
  height: string;
  /**
   * The action for image
   */
  selectAction: {
    /**
     * The type of action
     */
    type: string;
    /**
     * The title of action
     */
    title: string;
    /**
     * The type of image object
     */
    data: {
      /**
       *  The name of action
       */
      name: string;
      /**
       *  The type for data in actions
       */
      action: string;
      /**
       * The index of action
       */
      index: number;
      /**
       * The url for image to be replaced
       */
      newImageUrl: string;
    };
  };
}

/**
 * This is interface for elements in adaptive card
 */
export interface CardElement {
  /**
   * The type of element in adaptive card
   */
  type?: string;
  /**
   * The url of image
   */
  url?: string;
  /**
   * The altText of image
   */
  altText?: string;
  /**
   * The text in card element
   */
  text?: string;
  /**
   * The weight of text
   */
  weight?: string;
  /**
   * The items in card element
   */
  items?: CardElement[];
  /**
   * The columns in card element
   */
  columns?: CardElement[];
  /**
   * The flag for visibility of card element
   */
  isVisible?: boolean;
  /**
   * The id of card element
   */
  id?: string;
  /**
   * The action object for card element
   */
  selectAction?: ActionMetaData;
  /**
   * The action object for title of input toggle
   */
  title?: string;
}

/**
 * This is interface for adaptive card data
 */

export interface CardData {
  /**
   * The body object for adaptive card
   */
  body: CardElement[];
}

/**
 * This is interface for containers in combo card
 */
export interface ComboCard {
  [key: string]: Record<string, string> | Record<string, string>[];
}

/**
 * This is interfae for click event for actions in adaptive card
 */
interface ClickHandlerData {
  /**
   * The action for click event
   */
  action: ActionMetaData;
  /**
   * The card item in adaptive crad
   */
  cardItem: CardData;
  /**
   * The case id of active contact
   */
  caseId: string;
  /**
   * The flag for sm view
   */
  isSmView: boolean;
  /**
   * The id for card
   */
  cardId: number;

  activeInteractionID?: string;

  copilotSource?: string;
  /**
   * The email identifier
   */
  emailIdentifier?: string
}

/**
 * This are actions which are excluded in sm view
 */
const excludedActionsForSmView: string[] = [
  CardActions.EXPAND_IMAGE,
  CardActions.OPEN_LINKS_CONTAINER,
  CardActions.OPEN_IMAGES_CONTAINER,
  CardActions.OPEN_INTERNAL_USE_CONTAINER,
];

/**
 * This are actions for open container
 */
export const actionsForOpenContainer: string[] = [
  CardActions.OPEN_LINKS_CONTAINER,
  CardActions.OPEN_IMAGES_CONTAINER,
  CardActions.OPEN_PROCESS_STEPS_CONTAINER,
  CardActions.EXPAND_SUMMARY,
  CardActions.ADD_NEW_TOPICS,
  CardActions.CLEAR_TEXT,
  CardActions.OPEN_INTERNAL_USE_CONTAINER,
];

/**
 * This is enum for current status
 */
export enum ContentCurrentStatus {
  /**
   * The type for in progress status of content
   */
  IN_PROGRESS = 'In-Progress',
}

/**
 * These are actions corresponding to containers id
 */
const actionToContainerId: Record<CardActions, ContainerId> = {
  [CardActions.INSERT_ARTICLE]: ContainerId.KB_ANSWERS,
  [CardActions.SEND_ARTICLE]: ContainerId.KB_ANSWERS,
  [CardActions.INSERT_LINK]: ContainerId.KB_LINKS,
  [CardActions.SEND_LINK]: ContainerId.KB_LINKS,
  [CardActions.INSERT_IMAGE]: ContainerId.KB_IMAGES,
  [CardActions.SEND_IMAGE]: ContainerId.KB_IMAGES,
  [CardActions.EXPAND_IMAGE]: ContainerId.KB_IMAGES,
  [CardActions.INSERT_STEP]: ContainerId.KB_PROCESS_STEPS,
  [CardActions.SEND_STEP]: ContainerId.KB_PROCESS_STEPS,
  [CardActions.INSERT_STEPS]: ContainerId.KB_PROCESS_STEPS,
  [CardActions.SEND_STEPS]: ContainerId.KB_PROCESS_STEPS,
  [CardActions.OPEN_IMAGES_CONTAINER]: ContainerId.IMAGES_CONTAINER,
  [CardActions.OPEN_LINKS_CONTAINER]: ContainerId.WEB_CONTAINER,
  [CardActions.OPEN_PROCESS_STEPS_CONTAINER]:
    ContainerId.PROCESS_STEPS_CONTAINER,
  [CardActions.OPEN_INTERNAL_USE_CONTAINER]: ContainerId.INTERNAL_USE_CONTAINER,
  [CardActions.SEND_COMPLIANCE]: ContainerId.COMPLIANCE_CARDS,
  [CardActions.INSERT_COMPLIANCE]: ContainerId.COMPLIANCE_CARDS,
  [CardActions.SEARCH_TOPIC]: ContainerId.CONVERSATION_ASSISTANCE,
  [CardActions.REMOVE_TOPIC]: ContainerId.CONVERSATION_ASSISTANCE,
  [CardActions.INSERT_SALESOFFERS]: ContainerId.SALES_OFFERS,
  [CardActions.SEND_SALESOFFERS]: ContainerId.SALES_OFFERS,
  [CardActions.GENERATE_EMAIL_RESPONSE]: ContainerId.GENERATE_EMAIL_RESPONSE,
  [CardActions.HANDLE_INTENTS]: ContainerId.INTENT_ASSISTANCE,
  [CardActions.EXPAND_SUMMARY]: ContainerId.JOURNEY_SUMMARY,
  [CardActions.SEND_QUESTION]: ContainerId.BOT_ASSISTANCE_QUESTIONS_CONTAINER,
  [CardActions.SUBMIT_INTENTS]: ContainerId.INTENT_ASSISTANCE,
  [CardActions.OPEN_WORKFLOW_CONTAINER]: ContainerId.INTENT_ASSISTANCE,
  [CardActions.LIKE_TOPIC]: ContainerId.FEEDBACK_COMMENTS_CONTAINER_LIKE,
  [CardActions.DISLIKE_TOPIC]: ContainerId.FEEDBACK_COMMENTS_CONTAINER_DISLIKE,
  [CardActions.OPEN_FEEDBACK_TOPICS_CONTAINER]:
    ContainerId.FEEDBACK_COMMENTS_CONTAINER_LIKE,
  [CardActions.SAVE_FEEDBACK]: ContainerId.FEEDBACK_COMMENTS_CONTAINER_LIKE,
  [CardActions.GENERATE_EMAIL]: ContainerId.REPLY_GENERATING_CONTAINER,
  [CardActions.ADD_NEW_TOPICS]: ContainerId.SHOW_TOPIC_CONTAINER,
  [CardActions.CLEAR_TEXT]: ContainerId.SHOW_TOPIC_CONTAINER,
  [CardActions.LIKE]: ContainerId.KB_ANSWERS,
  [CardActions.DISLIKE]: ContainerId.KB_ANSWERS,
};

/**
 * Function to handle voice preference button click
 * @param data - adaptive card body
 * @example
 * ```
 * getImageUrl(data)
 * ```
 */
const getImageUrl = (card: CardData) => {
  const imgCard = card?.body?.filter((item) => item.type === 'Image') || [];
  return imgCard[0]?.url || '';
};

/**
 * Function to get url extension of image
 * @param url - url of image
 * @example
 * ```
 * getUrlExtension(url)
 * ```
 */
const getUrlExtension = (url: string) => {
  // extracting image extension from url ex - jpg, png
  return url?.split(/[#?]/)[0]?.split('.')?.pop()?.trim();
};

/**
 * Function to extract Data from card schema
 * @param element  - CardData
 * @param dataType  - string
 * @param action  - ActionMetaData
 * @example
 * ```
 * extractDataFromCardSchema(element, dataType, action)
 * ```
 */
const extractDataFromCardSchema = (
  element: CardElement,
  dataType:
    | AdaptiveCardType.TEXTBLOCK
    | AdaptiveCardType.IMAGE
    | AdaptiveCardType.ICONS,
  action?: string
) => {
  const dataBlocks: Array<string | CardElement> = [];
  extractDataFromElements(element, dataType, dataBlocks, action);
  return dataBlocks;
};

/**
 * Function to extract data from elements schema
 * @param cardSchema  - CardData
 * @param dataType  - string
 * @param dataBlocks  - Array
 * @param action  - ActionMetaData
 * @example
 * ```
 * extractDataFromElements(cardSchema)
 * ```
 */
const extractDataFromElements = (
  element: CardElement,
  dataType:
    | AdaptiveCardType.TEXTBLOCK
    | AdaptiveCardType.IMAGE
    | AdaptiveCardType.ICONS,
  dataBlocks: Array<string | CardElement>,
  action?: string
) => {
  switch (element.type) {
    case AdaptiveCardType.TEXTBLOCK:
      if (
        dataType === AdaptiveCardType.TEXTBLOCK &&
        element.text &&
        element.weight !== 'Bolder' &&
        element.id !== 'justificationText'
      ) {
        if (action === CardActions.INSERT_ARTICLE || action === CardActions.SEND_ARTICLE) {
          const plainText = element.text.replace(/\*\*\[.*?\]\(.*?\)\*\*/g, '.');
          dataBlocks.push(plainText);
        } else {
          dataBlocks.push(element.text);
        }
      }
      break;
    case AdaptiveCardType.IMAGE:
      if (
        dataType === AdaptiveCardType.IMAGE &&
        (element.id === 'images' ||
          element.id === 'likeTopic' ||
          element.id === 'dislikeTopic')
      ) {
        dataBlocks.push(element);
      }
      if (
        dataType === AdaptiveCardType.ICONS &&
        action &&
        element.selectAction &&
        element.selectAction.data &&
        element.selectAction.data.name === action
      ) {
        dataBlocks.push(element);
      }
      break;
    case AdaptiveCardType.CONTAINER:
      if (element.items) {
        for (const item of element.items) {
          extractDataFromElements(item, dataType, dataBlocks, action);
        }
      }
      break;
    case AdaptiveCardType.COLUMNSET:
      if (element.columns) {
        for (const column of element.columns) {
          extractDataFromElements(column, dataType, dataBlocks, action);
        }
      }
      break;
    case AdaptiveCardType.COLUMN:
      if (element.items) {
        for (const item of element.items) {
          extractDataFromElements(item, dataType, dataBlocks, action);
        }
      }
      break;
    case AdaptiveCardType.INPUT_TOGGLE:
      if (dataType === AdaptiveCardType.TEXTBLOCK && element.title) {
        dataBlocks.push(element.title);
      }
      break;
    default:
      break;
  }
};

/**
 * Function to get containerId from action
 * @param action - string
 * @example
 * ```
 * getContainerIdFromAction(action)
 * ```
 */
const getContainerIdFromAction = (action: CardActions) => {
  return actionToContainerId[action] || '';
};

/**
 * Function to execute card action
 * @param data - ClickHandlerData
 * @param handleIconChange - any
 * @param handleExpandImageClick - any
 * @param dispatch - any
 * @example
 * ```
 * executeCardAction(data, containerId , handleIconChange, handleExpandImageClick, dispatch)
 * ```
 */
const executeCardAction = async (
  {
    action,
    cardItem,
    caseId,
    cardId,
    activeInteractionID,
    copilotSource,
  }: ClickHandlerData,
  containerId: string,
  handleIconChange: any,
  handleExpandImageClick: any,
  dispatch: any,
  agentName: string,
  copilotConfigurations?: any
) => {
  if (
    action.data?.buttonAction === CardActions.LIKE_TOPIC ||
    action.data?.buttonAction === CardActions.DISLIKE_TOPIC
  ) {
    const index = +(action.data?.index ?? 0) + 1;
    const itemsContainer = cardItem.body[index].items as CardElement[];
    const iconsContainer = itemsContainer[0];
    if (action.data?.buttonAction === CardActions.LIKE_TOPIC) {
      if (iconsContainer.columns && iconsContainer.columns.length > 1) {
        const likeColumnsContainer = iconsContainer.columns[1];
        const dislikeColumnsContainer = iconsContainer.columns[2];
        if (likeColumnsContainer && likeColumnsContainer.items) {
          let updateLikeCommentsContainerVisibility = false;
          const updatedItems = likeColumnsContainer.items.map((item) => {
            if (item.isVisible !== undefined) {
              if (item.isVisible && !item.id?.includes('likedIcon')) {
                updateLikeCommentsContainerVisibility = true;
              }
              return { ...item, isVisible: !item.isVisible };
            }
            return item;
          });
          if (updateLikeCommentsContainerVisibility) {
            itemsContainer[1].isVisible = true;
            itemsContainer[2].isVisible = false;
          } else {
            itemsContainer[1].isVisible = false;
          }
          if (dislikeColumnsContainer && dislikeColumnsContainer.items) {
            if (dislikeColumnsContainer.items[1].isVisible) {
              dislikeColumnsContainer.items[1].isVisible = false;
              dislikeColumnsContainer.items[0].isVisible = true;
            }
          }
          const updatedColumnsContainer = {
            ...likeColumnsContainer,
            items: updatedItems,
          };
          const updatedColumnsArray = [...iconsContainer.columns];
          updatedColumnsArray[1] = updatedColumnsContainer;
          const updatedIconsContainer = {
            ...iconsContainer,
            columns: updatedColumnsArray,
          };
          itemsContainer[0] = updatedIconsContainer;
        }
      }
    }
    if (action.data?.buttonAction === CardActions.DISLIKE_TOPIC) {
      if (iconsContainer.columns && iconsContainer.columns.length > 1) {
        const likeColumnsContainer = iconsContainer.columns[1];
        const dislikeColumnsContainer = iconsContainer.columns[2];
        if (dislikeColumnsContainer && dislikeColumnsContainer.items) {
          let updateDislikeCommentsContainerVisibility = false;
          const updatedItems = dislikeColumnsContainer.items.map((item) => {
            if (item.isVisible && !item.id?.includes('dislikedIcon')) {
              updateDislikeCommentsContainerVisibility = true;
            }
            if (item.isVisible !== undefined) {
              return { ...item, isVisible: !item.isVisible };
            }
            return item;
          });
          if (updateDislikeCommentsContainerVisibility) {
            itemsContainer[2].isVisible = true;
            itemsContainer[1].isVisible = false;
          } else {
            itemsContainer[2].isVisible = false;
          }

          if (likeColumnsContainer && likeColumnsContainer.items) {
            if (likeColumnsContainer.items[1].isVisible) {
              likeColumnsContainer.items[1].isVisible = false;
              likeColumnsContainer.items[0].isVisible = true;
            }
          }

          const updatedColumnsContainer = {
            ...dislikeColumnsContainer,
            items: updatedItems,
          };
          const updatedColumnsArray = [...iconsContainer.columns];
          updatedColumnsArray[2] = updatedColumnsContainer;
          const updatedIconsContainer = {
            ...iconsContainer,
            columns: updatedColumnsArray,
          };
          itemsContainer[0] = updatedIconsContainer;
        }
      }
    }
    dispatch(
      updateAdaptiveCardSchema({
        updatedCopilotCard: cardItem.body[index],
        caseId,
        cardId,
        containerId: containerId,
        feedbackIndex: index,
        feedbackIcons: true,
      })
    );
    return;
  }
  const cardContainer = getContainerById(cardItem.body, containerId);
  const actionName = action.data?.name;
  switch (actionName) {
    case CardActions.INSERT_ARTICLE:
    case CardActions.SEND_ARTICLE: {
      const textBlocks = extractDataFromCardSchema(
        cardContainer,
        AdaptiveCardType.TEXTBLOCK,
        actionName
      );
      const articleResponse = `${textBlocks[0]}`;
      handleInsertOrSendData(
        articleResponse,
        actionName,
        caseId,
        dispatch
      );
      break;
    }
    case CardActions.INSERT_LINK:
    case CardActions.SEND_LINK: {
      const linkResponse = action.data?.link || '';
      handleInsertOrSendData(
        actionName === CardActions.SEND_LINK
          ? 'Link :' + linkResponse
          : linkResponse,
        actionName,
        caseId,
        dispatch
      );
      break;
    }
    case CardActions.INSERT_IMAGE:
    case CardActions.SEND_IMAGE:
    case CardActions.EXPAND_IMAGE: {
      const imagesArray = extractDataFromCardSchema(
        cardContainer,
        AdaptiveCardType.IMAGE
      ) as CardElement[];
      const imagesIndex = +(action.data?.index ?? 0);
      const imageToAdd = await getImageDetails(imagesArray, imagesIndex);
      if (
        (actionName === CardActions.SEND_IMAGE ||
          actionName === CardActions.INSERT_IMAGE) &&
        copilotSource === 'JSON'
      ) {
        const imageResponse = {
          friendlyName: imageToAdd.selectedFile?.name ?? 'defaultName',
          url: imageToAdd.imgUrl,
        };
        if (copilotSource === 'JSON') {
          handleInsertOrSendData(
            'IMAGE :' + imageToAdd.imgUrl,
            actionName,
            caseId,
            dispatch
          );
        }
      } else {
        if (
          actionName === CardActions.SEND_IMAGE &&
          copilotSource === 'Live LLM'
        ) {
          //sendInChat(imageResponse, caseId, dispatch);
          const imagesResponse = [
            {
              type: 'image',
              isItemSent: true,
              isItemSelected: true,
              imgSrc: imageToAdd.imgUrl,
              id: 1,
            },
          ];
          const replyMessage = {
            messageId: new Date().toString(),
            postId:
              'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
            isOwn: true,
            createdAt: formatMsgTime(),
            messageContent: {
              payload: {
                text: '',
                linkContent: [],
                imageContent: imagesResponse ?? [],
                processContent: [],
              },
            },
            reactionStatistics: {
              likes: 0,
            },
            authorUser: {
              firstName: agentName,
              surname: '',
              emailAddress: 'customer.service@delta.com',
              loginUsername: '',
            },
            attachments: [],
            conferenceMsg: false,
            summaryCardName: '',
          };
          // dispatch(updateFileToBeUploaded(dataTransfer.files));
          dispatch(
            updateTwitterAgentReply({
              interactionId: activeInteractionID,
              replyMessage,
            })
          );
        } else if (actionName === CardActions.EXPAND_IMAGE) {
          const img = imagesArray[imagesIndex ?? 0] as CardElement;
          const imgUrl = `${img?.url || ''}`;
          const imagAltText = `${img?.url || ''}`;
          handleExpandImageClick(imgUrl, imagAltText);
          return;
        } else {
          const dataTransfer = new DataTransfer();
          if (imageToAdd.selectedFile) {
            dataTransfer.items.add(imageToAdd.selectedFile);
          } else {
            console.error('Selected file is undefined.');
          }
          //TODO
          const imageResponse = {
            friendlyName: imageToAdd.selectedFile?.name ?? 'defaultName',
            url: imageToAdd.imgUrl,
          };
          insertTextInEditor(imageResponse, caseId, dispatch);
        }
      }
      break;
    }
    case CardActions.INSERT_STEP:
    case CardActions.SEND_STEP: {
      const textIndex = +(action.data?.index ?? 0);
      const cardContainer = getContainerById(
        cardItem.body,
        ContainerId.KB_PROCESS_STEPS
      );
      if (cardContainer && cardContainer.items) {
        const textBlocks = extractDataFromCardSchema(
          cardContainer.items[textIndex + 1],
          AdaptiveCardType.TEXTBLOCK
        ) as CardElement[];
        const stepResponse = textBlocks && textBlocks.join(' ');
        handleInsertOrSendData(
          stepResponse,
          actionName,
          caseId,
          dispatch
        );
      }
      break;
    }
    case CardActions.INSERT_STEPS:
    case CardActions.SEND_STEPS: {
      const textBlocks = extractDataFromCardSchema(
        cardContainer,
        AdaptiveCardType.TEXTBLOCK
      ) as string[];
      const stepsResponse = getProcessSteps(textBlocks, actionName);
      handleInsertOrSendData(
        stepsResponse,
        actionName,
        caseId,
        dispatch
      );
      break;
    }
    case CardActions.SEARCH_TOPIC: {
      const searchTopic = `Tell me about ${action.data?.topic}`;
      dispatch(setAgentSearchTopic(searchTopic));
      break;
    }
    case CardActions.REMOVE_TOPIC: {
      const index = action.data?.index as any as number;
      const topic = action.data?.topic;
      topic &&
        dispatch(
          removeConversationAssistanceItem({
            caseId: `${caseId}`,
            assistanceId: index,
            topic: topic,
          })
        );
      break;
    }
    case CardActions.INSERT_COMPLIANCE:
    case CardActions.SEND_COMPLIANCE: {
      const textBlocks = extractDataFromCardSchema(
        cardContainer,
        AdaptiveCardType.TEXTBLOCK
      );
      const complianceResponse = `${textBlocks[0]}`;
      handleInsertOrSendData(
        complianceResponse,
        actionName,
        caseId,
        dispatch
      );
      break;
    }
    case CardActions.INSERT_SALESOFFERS:
    case CardActions.SEND_SALESOFFERS: {
      const textBlocks = extractDataFromCardSchema(
        cardContainer,
        AdaptiveCardType.TEXTBLOCK
      );
      const salesOffersResponse = textBlocks && textBlocks.join('\n');
      handleInsertOrSendData(
        salesOffersResponse,
        actionName,
        caseId,
        dispatch
      );
      break;
    }
    case CardActions.EXPAND_SUMMARY: {
      if (cardItem.body) {
        const journeySummaryMainContainer = getContainerById(
          cardItem.body,
          ContainerId.JOURNEY_SUMMARY_CONTAINER
        );
        handleContainerOpen(
          journeySummaryMainContainer,
          cardId,
          ContainerId.JOURNEY_SUMMARY_CONTAINER,
          caseId,
          dispatch
        );
        if (cardContainer.isVisible !== undefined) {
          cardContainer.isVisible = !cardContainer.isVisible;
        }
        dispatch(
          updateAdaptiveCardSchema({
            updatedCopilotCard: cardContainer,
            caseId,
            cardId,
            containerId,
          })
        );
        cardContainer.isVisible !== undefined &&
          dispatch(
            updateIsJourneySummaryExpanded({
              isJourneySummaryExpanded: cardContainer.isVisible,
              caseId,
            })
          );
      }
      break;
    }
    case CardActions.SEND_QUESTION: {
      const textIndex = +(action.data?.index ?? 0);
      const textQuestion = action.data?.text;
      const choices = action.data?.choices ?? [];
      choices.push({
        title: 'None of these',
        value: 'None of these',
      });
      let formedQuestion = `${textQuestion}${'\n'}`;
      choices?.forEach((choice: any, index: any) => {
        formedQuestion += `${index + 1}. ${choice.title}${'\n'}`;
      });
      //const cardContainer = getContainerById(cardItem.body, ContainerId.BOT_ASSISTANCE_QUESTIONS_CONTAINER);
      // if (cardContainer && cardContainer.items) {
      //   const textBlocks = extractDataFromCardSchema(cardContainer.items[textIndex + 1], AdaptiveCardType.TEXTBLOCK) as CardElement[];
      //   const stepResponse = textBlocks && textBlocks.join(' ');
      const replyMessage = {
        messageId: new Date().toString(),
        postId:
          'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        isOwn: true,
        createdAt: formatMsgTime(),
        messageContent: {
          payload: {
            text: formedQuestion,
          },
        },
        reactionStatistics: {
          likes: 0,
        },
        authorUser: {
          firstName: 'Copilot',
          surname: '',
          emailAddress: 'bot@nice.com',
          loginUsername: '',
        },
        attachments: [],
        conferenceMsg: false,
        summaryCardName: '',
      };

      dispatch(
        updateTwitterAgentReply({
          interactionId: activeInteractionID,
          replyMessage,
        })
      );
      document.getElementById('bodyContainer')?.scroll({
        top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
        behavior: 'smooth', //auto, smooth, initial, inherit
      });
      //handleInsertOrSendData(stepResponse, actionName, caseId, dispatch);
      //}
      break;
    }
    case CardActions.OPEN_WORKFLOW_CONTAINER: {
      const workflowQuestionsContainer = getContainerById(
        cardItem.body,
        ContainerId.WORKFLOW_QUESTIONS_CONTAINER
      );
      handleContainerOpen(
        workflowQuestionsContainer,
        cardId,
        ContainerId.WORKFLOW_QUESTIONS_CONTAINER,
        caseId,
        dispatch
      );
      break;
    }
    case CardActions.SAVE_FEEDBACK: {
      dispatch(isFeedbackSaved({ caseId, isFeedbackSaved: true }));
      break;
    }
    case CardActions.GENERATE_EMAIL: {
      const { comments, updatedCopilotCard, filteredEmailTopics } = extractTopicsFromAction(action, cardItem);
      const emptyCommentCheck = comments?.every((comment) => comment?.content?.trim().length === 0);
      if (filteredEmailTopics?.length !== 0 || (comments?.length !== 0 && !emptyCommentCheck)) {
      dispatch(updateAdaptiveCardSchema({ updatedCopilotCard, caseId, cardId, containerId }));
      const combinedTopics = filteredEmailTopics.concat(comments);
      if (action?.data?.emailTopics) {
        await generateEmail(caseId, combinedTopics, dispatch, copilotConfigurations);
      }
      } else {
        const updatedCopilotCard = cardItem?.body?.map((item: CardElement) => {
          if (item.id === ContainerId.INITIAL_CONTAINER) {
            const items = item.items || [];
            return {
              ...item,
              items: updateCardItemsforEmail(items),
            };
          }
          return item;
        });
        dispatch(updateAdaptiveCardSchema({ updatedCopilotCard, caseId, cardId, containerId }));
      }
      return;
    }
    case CardActions.CLEAR_TEXT: {
      const checkedBoxed = action?.data?.customOption ?? '';
      const textInputId = action?.data?.textInputId;
      const lastElementId = textInputId[textInputId?.length - 1];
      const updatedCopilotCard = modifyCopilotCardTopics(cardItem, action, checkedBoxed);
      const finalUpdatedCopilotCard: CardElement[] = updateAdaptiveCardforEmail(updatedCopilotCard, +lastElementId, textInputId, action);
      finalUpdatedCopilotCard &&
        dispatch(updateAdaptiveCardSchema({ updatedCopilotCard: finalUpdatedCopilotCard, caseId, cardId, containerId }));
      break;
    }
    case CardActions.ADD_NEW_TOPICS: {
      const checkedBoxed = action?.data?.customOption ?? '';
      const updatedCopilotCard = modifyCopilotCardTopics(cardItem, action, checkedBoxed);
      const finalUpdatedCopilotCard: CardElement[] = updateAdaptiveCardforEmail(updatedCopilotCard, -1, '', action);
      finalUpdatedCopilotCard &&
        dispatch(updateAdaptiveCardSchema({ updatedCopilotCard: finalUpdatedCopilotCard, caseId, cardId, containerId }));
      break;
    }
  }
  const bodyContainer = document.getElementById('bodyContainer');
  if (bodyContainer) {
    setTimeout(() => {
      bodyContainer.scrollTop = bodyContainer.scrollHeight;
    }, 100);
  }
  handleIconChange(
    cardContainer,
    action,
    cardId,
    caseId,
    containerId,
    dispatch
  );
};

/**
 * Function to handle on click event for actions
 * @param data - ClickHandlerData
 * @param handleIconChange - any
 * @param handleExpandImageClick - any
 * @param dispatch - any
 * @example
 * ```
 * handleClickActions(data, handleIconChange, handleExpandImageClick, dispatch)
 * ```
 */
const handleClickActions = async (
  {
    action,
    cardItem,
    caseId,
    isSmView,
    cardId,
    activeInteractionID,
    copilotSource,
  }: ClickHandlerData,
  handleIconChange: any,
  handleExpandImageClick: any,
  dispatch: any,
  agentName: string,
  copilotConfigurations?: any
) => {
  const actionsofAdaptiveCard = [
    CardActions.INSERT_ARTICLE,
    CardActions.SEND_ARTICLE,
    CardActions.INSERT_LINK,
    CardActions.SEND_LINK,
    CardActions.INSERT_IMAGE,
    CardActions.SEND_IMAGE,
    CardActions.EXPAND_IMAGE,
    CardActions.INSERT_STEP,
    CardActions.SEND_STEP,
    CardActions.INSERT_STEPS,
    CardActions.SEND_STEPS,
    CardActions.SEARCH_TOPIC,
    CardActions.REMOVE_TOPIC,
    CardActions.INSERT_COMPLIANCE,
    CardActions.SEND_COMPLIANCE,
    CardActions.INSERT_SALESOFFERS,
    CardActions.SEND_SALESOFFERS,
    CardActions.EXPAND_SUMMARY,
    CardActions.SEND_QUESTION,
    CardActions.LIKE_TOPIC,
    CardActions.DISLIKE_TOPIC,
    CardActions.SAVE_FEEDBACK,
    CardActions.GENERATE_EMAIL,
    CardActions.ADD_NEW_TOPICS,
    CardActions.CLEAR_TEXT,
    CardActions.LIKE,
    CardActions.DISLIKE,
  ];
  const cardActionName = action.data?.name;
  actionsofAdaptiveCard.forEach((actionName) => {
    if (
      cardActionName === actionName ||
      action.data?.buttonAction === actionName
    ) {
      executeCardAction(
        {
          action,
          cardItem,
          caseId,
          isSmView,
          cardId,
          activeInteractionID,
          copilotSource,
        },
        getContainerIdFromAction(actionName),
        handleIconChange,
        handleExpandImageClick,
        dispatch,
        agentName,
        copilotConfigurations
      );
    }
  });

  if (
    isSmView &&
    action.data &&
    !excludedActionsForSmView.includes(cardActionName)
  ) {
    //dispatch(globalActions.setSelectedMenu({ name: 'Interaction' }));
  }
};

/**
 * Function to update the visibility of items in a list
 * @param items - An array of items, each with an id and visibility property
 * @returns An array of items with updated visibility
 * @example 
 * ```
 * const updatedItems = updateItemsVisibility(items);
 * ```
 */
const updateItemsVisibility = (items: any) => {
  return items?.map((item: any) => {
    if (item.id === ContainerId.SHOW_TOPIC_CONTAINER) {
      return { ...item, isVisible: !item.isVisible };
    }
    if (item.items) {
      return { ...item, items: updateItemsVisibility(item.items) };
    }
    return item;
  });
};

/**
 * Function to update an email Adaptive Card
 * @param card - Array of CardElement objects representing the current state of the card
 * @param action - The action to be performed on the card
 * @returns An array of CardElement objects representing the updated state of the card
 * @example
 * ```
 * const updatedCard = updateAdaptiveCardforEmail(card, action);
 * ```
 */
function updateAdaptiveCardforEmail(card: CardElement[], topicContainerIndex = -1, textInputId?: string, action?: ActionMetaData) {
  const container =
  card[0]?.items
    ?.find((item) => item.id === ContainerId.RESPONSE_OPTION_CONTAINER)
    ?.items?.find((item) => item.id === ContainerId.TOPIC_CONTAINER) ?? null;
  let filteredTopic = container?.items;
  if(topicContainerIndex >= 0 && container?.items){
    filteredTopic = container?.items?.filter(item => item?.id !== textInputId);
  }else{
    const existingTopicContainers = filteredTopic?.filter((item) => item.id?.startsWith(ContainerId.SHOW_TOPIC_CONTAINER)) ?? [];
    const showTopicContainerIndex = existingTopicContainers.length;
    const actionData = action?.data;
    const customKey = `customTopics${showTopicContainerIndex}`;
    const customTopicValue = actionData ? actionData[customKey as keyof ActionMetaData['data']] : '';
    if (filteredTopic && showTopicContainerIndex < 3) {
      const newColumnSet = {
        type: 'ColumnSet',
        id: `showTopicContainer${showTopicContainerIndex}`,
        columns: [
          {
            type: 'Column',
            width: 'auto',
            items: [
              {
                type: 'Input.Toggle',
                id: `checkbox${showTopicContainerIndex}`,
                value: 'true',
              }
            ],
            value: 'customTopics0, customTopics1, customTopics2',
            verticalContentAlignment: 'Center',
          },
          {
            type: 'Column',
            width: 'stretch',
            id: `inputText${showTopicContainerIndex}`,
            items: [
              {
                type: 'Input.Text',
                id: `customTopics${showTopicContainerIndex}`,
                placeholder: 'adp_enterNewTopic',
                value: customTopicValue,
              }
            ],
          },
          {
            type: 'Column',
            width: 'auto',
            id: `clearButton${showTopicContainerIndex}`,
            items: [
              {
                type: 'ActionSet',
                actions: [
                  {
                    type: 'Action.Submit',
                    verticalContentAlignment: 'Center',
                    iconUrl: copilotActionIcons.AdaptiveCardClearTextBlockIcon,
                    data: {
                      name: 'clearText',
                      textInputId: `showTopicContainer${showTopicContainerIndex}`,
                    },
                  }
                ],
              }
            ],
          }
        ],
      };
      filteredTopic.splice(showTopicContainerIndex, 0, newColumnSet);
    }
  }

  if (filteredTopic) {
    filteredTopic = filteredTopic.map((item, index) => {
      if (!item?.id?.startsWith(ContainerId.SHOW_TOPIC_CONTAINER)) {
        return item;
      }
      item.id = `showTopicContainer${index}`;
      const columns = item.columns;
      if (!columns || !columns[0]?.items?.[0] || !columns[1]?.items?.[0] || !columns[2]?.items?.[0]) {   // This check ensures that the columns array and the first item in each column are defined to avoid runtime errors.
        return item;
      }
      columns[0].items[0].id = `checkbox${index}`;
      columns[1].items[0].id = `customTopics${index}`;
      const actionSet = columns[2].items[0] as { actions: { data: { textInputId: string } }[] };
      const actions = actionSet.actions;
      if (actions?.[0]?.data) {
        actions[0].data.textInputId = `showTopicContainer${index}`;
      }
      return item;
    });
  }
  if (container) {
    container.items = filteredTopic;
  }
  const totalBlocks = filteredTopic?.filter(item => item?.id && item.id.startsWith(ContainerId.SHOW_TOPIC_CONTAINER)).length || 0;
  const addTopicButton = filteredTopic?.find((item) => item.id === ContainerId.ADD_TOPIC_ACTION_CONTAINER);
  if (addTopicButton) {
    addTopicButton.isVisible = totalBlocks <= 2;
  }
  return card;
}

/**
 * Function to update card items by setting visibility and values for specific containers.
 * @param items - The card items to be updated.
 * @returns The updated card items.
 * @example
 * ```typescript
 * const result = updateCardItemsforEmail(items);
 * ```
 */
const updateCardItemsforEmail = (items: CardElement[]): CardElement[] => {
  return items.map((subItem: CardElement) => {
    if (subItem.id === ContainerId.ERROR_MESSAGE_CONTAINER) {
      return { ...subItem, isVisible: true };
    }
    if (subItem.id === ContainerId.RESPONSE_OPTION_CONTAINER) {
      const responseItems = subItem.items || [];
      return {
        ...subItem,
        items: responseItems.map((innerItem: CardElement) => {
          if (innerItem.id === 'customOption') {
            return { ...innerItem, value: '' };
          }
          return innerItem;
        }),
      };
    }
    return subItem;
  });
};

/**
 * Function to extract topics and id from an action
 * @param data - The data object containing comments and other relevant data
 * @param cardItem - The card item to be updated
 * @returns An object containing comments, updatedCopilotCard, and filteredEmailTopics
 * @example 
 * ```
 * const result = extractTopicsFromAction(data, cardItem);
 * ```
 */
const extractTopicsFromAction = (action: ActionMetaData, cardItem: CardData) => {
  const comments = [action?.data?.customTopics0, action?.data?.customTopics1, action?.data?.customTopics2]
    .reduce<{ topicId: string; content: string }[]>((topic, comment) => {
      if (comment) {
        topic.push({
          topicId: `topic${topic.length}`,
          content: comment,
        });
      }
      return topic;
    }, []);
  
  const updatedCopilotCard = cardItem?.body?.map((item: CardElement) => {
    return { ...item, isVisible: !item.isVisible };
  });
  let filteredEmailTopics: { topicId: string; content: string }[] = [];
  if (action.data?.customOption) {
    filteredEmailTopics = mapSelectedEmailTopics(action.data?.customOption, action.data?.emailTopics ?? []);
  }
  return { comments, updatedCopilotCard, filteredEmailTopics };
};

/**
 * Function to map selected email topics based on a custom option
 * @param customOption - A string of comma-separated topic IDs
 * @param emailTopics - An array of objects, each containing a topicId and content
 * @returns An array of objects, each containing a topicId and content, filtered based on the customOption
 * @example 
 * ```
 * const filteredTopics = mapSelectedEmailTopics(customOption, emailTopics);
 * ```
 */
function mapSelectedEmailTopics(customOption: string, emailTopics: {topicId: string, content: string}[]) {
  const customOptionArray = customOption.split(',').map(option => option.trim());

  return emailTopics.reduce<{ topicId: string; content: string }[]>((filteredTopics, currentTopic) => {
    if (customOptionArray.includes(currentTopic.topicId)) {
      filteredTopics.push({
        topicId: currentTopic?.topicId,
        content: currentTopic?.content,
      });
    }
    return filteredTopics;
  }, []);
}

/**
 * Modifies the topics in the Copilot card based on the provided action and checkedBoxed value.
 * @param cardData - The data of the card to be modified.
 * @param action - The action containing data to update the card.
 * @returns The updated card data with modified topics.
 * @example 
 * ```
 * const updatedCard = modifyCopilotCardTopics(card, action);
 * ```
 */
const modifyCopilotCardTopics = (cardItem: CardData, action: ActionMetaData, checkedBoxed: string) => {
  return cardItem?.body?.map((item: CardElement) => {
    if (item.id === ContainerId.INITIAL_CONTAINER) {
      const items = item.items || [];
      const updatedItems = items.map((subItem: CardElement) => {
        if (subItem.id === ContainerId.RESPONSE_OPTION_CONTAINER) {
          const responseItems = subItem.items || [];
          return {
            ...subItem,
            items: responseItems.map((innerItem: CardElement) => {
              if (innerItem.id === ContainerId.CUSTOM_OPTION_CONTAINER) {
                return { ...innerItem, value: checkedBoxed };
              }
              if (innerItem.id === ContainerId.TOPIC_CONTAINER) {
                const topicItems = innerItem.items || [];
                const updatedTopicItems = topicItems.map((topicItem: CardElement, index) => {
                  if (topicItem.id === `showTopicContainer${index}`) {
                    const columns = topicItem.columns || [];
                    const updatedColumns = columns.map((column: CardElement) => {
                      const columnItems = column.items || [];
                      const actionData = action?.data;
                      const customKey = `customTopics${index}`;
                      const customOptionText = actionData ? actionData[customKey as keyof ActionMetaData['data']] : '';

                      const updatedColumnItems = columnItems.map((columnItem: CardElement) => {
                        if (columnItem.id === `customTopics${index}`) {
                          return { ...columnItem, value: customOptionText };
                        }
                        return columnItem;
                      });

                      return { ...column, items: updatedColumnItems };
                    });
                    return { ...topicItem, columns: updatedColumns };
                  }
                  return topicItem;
                });

                return { ...innerItem, items: updatedTopicItems };
              }
              return innerItem;
            }),
          };
        }
        return subItem;
      });
      return { ...item, items: updatedItems };
    }
    return item;
  });
};

/**
 * Function to formatMsgTime
 * @example
 * ```
 * formatMsgTime
 * ```
 */
const formatMsgTime = () => {
  const date = new Date();
  const result = date.toUTCString();
  return result;
};

/**
 * Function to handle inserting intent messages
 * @param caseId - any
 * @param intents - any
 * @param userReplyChatData - any
 * @param dispatch - any
 * @example
 * ```
 * handleInsertingIntentMessages(data, handleIconChange, handleExpandImageClick, dispatch)
 * ```
 */
const handleInsertingIntentMessages = async (
  caseId: any,
  intents: any,
  userReplyChatData: any,
  agentName: any,
  customerName: any,
  lastindexVal: any,
  activeInteractionID: any,
  dispatch: any
) => {
  let intentIndexVal = 0;
  let intervalTime = 3000;
  let randomButtonText = '';
  const messagesToAddWithCustomerResponse = intents[0]?.tasks.flatMap(
    (task: any) => {
      //let buttonTexts = task?.buttons?.map((button: any) => button.text);
      const lastIndex = task?.buttons?.length + 1;
      const buttonTexts =
        task?.buttons
          ?.map((button: any, index: any) => `${index + 1}. ${button.text}\n`)
          .join('') + `${lastIndex}. None of these`;
      const taskMessage = {
        type: 'bot',
        postiveMsg: task?.buttons
          ? `${task.text}${'\n'}${buttonTexts}${'\n'}`
          : task.text,
        agentName: agentName,
        card: '',
      };

      if (task.buttons) {
        intervalTime = task.buttons?.[intentIndexVal].time ?? 3000;
        //const buttonTexts = task.buttons.map((button: any) => button.text);
        //randomButtonText = buttonTexts.length > 1 ? buttonTexts[Math.floor(Math.random() * (buttonTexts.length - 1)) + 1] : null;
        randomButtonText = task.buttons[0].text;
        const messages = [
          taskMessage,
          randomButtonText
            ? {
                type: 'customer',
                postiveMsg: randomButtonText,
                agentName: agentName,
                card: '',
              }
            : {},
        ];
        return messages;
      } else {
        return taskMessage;
      }
    }
  );

  const loop = setInterval(() => {
    if (intentIndexVal < messagesToAddWithCustomerResponse.length) {
      const currentDate = new Date().toLocaleDateString();
      const userReply = messagesToAddWithCustomerResponse[
        intentIndexVal
      ].postiveMsg
        .replace('%%date%%', currentDate)
        .replace('%%time%%', randomButtonText);
      const replyMessage = {
        messageId: new Date().toString(),
        postId:
          'chat_1359751597379620865_b81029d6-f53b-406b-8bef-314d1eabb2341',
        isOwn: true,
        createdAt: formatMsgTime(),
        messageContent: {
          payload: {
            text: userReply,
          },
        },
        reactionStatistics: {
          likes: 0,
        },
        authorUser: {
          firstName:
            messagesToAddWithCustomerResponse[intentIndexVal].type === 'bot'
              ? 'Copilot'
              : messagesToAddWithCustomerResponse[intentIndexVal].type ===
                'agent'
              ? ''
              : 'Clark',
          surname:
            messagesToAddWithCustomerResponse[intentIndexVal].type === 'bot'
              ? ''
              : messagesToAddWithCustomerResponse[intentIndexVal].type ===
                'agent'
              ? messagesToAddWithCustomerResponse[
                  intentIndexVal
                ].agentName.split(' ')[0]
              : 'Kent',
          emailAddress:
            messagesToAddWithCustomerResponse[intentIndexVal].type === 'bot'
              ? 'bot@nice.com'
              : messagesToAddWithCustomerResponse[intentIndexVal].type ===
                'agent'
              ? 'customer.service@delta.com'
              : 'clarkkent@do31.com',
          loginUsername: '',
        },
        attachments: [],
        conferenceMsg: false,
        summaryCardName: messagesToAddWithCustomerResponse[intentIndexVal].card,
      };

      dispatch(
        updateTwitterAgentReply({
          interactionId: activeInteractionID,
          replyMessage,
        })
      );
      intentIndexVal = intentIndexVal + 1;
    } else {
      clearInterval(loop);
    }
    document.getElementById('bodyContainer')?.scroll({
      top: document.getElementById('bodyContainer')?.scrollHeight, //scroll to the bottom of the element
      behavior: 'smooth', //auto, smooth, initial, inherit
    });
  }, intervalTime);
};

/**
 * Function to handle insert or send action
 * @param response - string
 * @param action - action name
 * @param caseId - string
 * @param dispatch - any
 * @example
 * ```
 * handleInsertOrSendData(response, action, handleExpandImageClick, dispatch)
 * ```
 */
const handleInsertOrSendData = async (
  response: string,
  action: string,
  caseId: string,
  dispatch: any
) => {
  if (action.startsWith('send')) {
    //dispatch(sendCopilotReply({ caseId, response}));
    sendInChat(response, caseId, dispatch);
  } else {
    insertTextInEditor(response, caseId, dispatch, action);
  }
};

/**
 * Function to handle toggling of like/dislike icons
 * @param item - CardElement
 * @param actionName - ActionMetaData
 * @param copilotActionIcons - string
 * @example
 * ```
 * toggleLikeDislikeHandler(item, actionName, copilotActionIcons)
 * ```
 */
const toggleLikeDislikeHandler = (
  item: CardElement,
  actionName: string,
  copilotActionIcons: any
): void => {

  const likeItem = item?.columns?.find(
    (column) => column?.items && column?.items[0]?.id === 'likeIcon'
  );
  const dislikeItem = item?.columns?.find(
    (column) => column?.items && column?.items[0]?.id === 'dislikeIcon'
  );

  if (actionName === CardActions.LIKE) {
    if (likeItem && likeItem.items && likeItem.items[0]) {
      likeItem.items[0].url =
        likeItem.items[0].url ===
        copilotActionIcons.AdaptiveCardLikeClickedIcon
          ? copilotActionIcons.AdaptiveCardLikeIcon
          : copilotActionIcons.AdaptiveCardLikeClickedIcon;
    }
    if (dislikeItem && dislikeItem.items && dislikeItem.items[0]) {
      dislikeItem.items[0].url =
        copilotActionIcons.AdaptiveCardDislikeIcon;
    }
  }

  if (actionName === CardActions.DISLIKE) {
    if (dislikeItem && dislikeItem.items && dislikeItem.items[0]) {
      dislikeItem.items[0].url =
        dislikeItem.items[0].url ===
        copilotActionIcons.AdaptiveCardDislikeClickedIcon
          ? copilotActionIcons.AdaptiveCardDislikeIcon
          : copilotActionIcons.AdaptiveCardDislikeClickedIcon;
    }
    if (likeItem && likeItem.items && likeItem.items[0]) {
      likeItem.items[0].url = copilotActionIcons.AdaptiveCardLikeIcon;
    }
  }
};

/**
 * Function to handle on click for icons
 * @param containerCard - CardElement
 * @param action - ActionMetaData
 * @param cardId - number
 * @param caseId - string
 * @param containerId - string
 * @param dispatch - any
 * @example
 * ```
 * handleIconChange(containerCard, action, cardId, caseId, containerId, dispatch)
 * ```
 */
const handleIconChange = (
  containerCard: CardElement,
  action: ActionMetaData,
  cardId: number,
  caseId: string,
  containerId: string,
  dispatch: any
) => {
  const actionName = action.data?.name;
  if (
    actionName === CardActions.REMOVE_TOPIC ||
    actionName === CardActions.SEARCH_TOPIC
  ) {
    return;
  }
  const icons = extractDataFromCardSchema(
    containerCard,
    AdaptiveCardType.ICONS,
    actionName
  );
  if (icons.length > 0) {
    let imageIndex = 0;
    const excludedActions = [
      CardActions.INSERT_ARTICLE,
      CardActions.SEND_ARTICLE,
      CardActions.INSERT_SALESOFFERS,
      CardActions.SEND_SALESOFFERS,
      CardActions.INSERT_COMPLIANCE,
      CardActions.SEND_COMPLIANCE,
      CardActions.SEND_QUESTION
    ];

    if (!excludedActions.includes(actionName as CardActions)) {
      imageIndex = +(action.data?.index ?? 0);
    }
    const updatedImage = action.data?.newImageUrl;
    const iconToUpdate = icons[
      imageIndex
    ] as unknown as AdaptiveCardImageObject;
    if (actionName !== CardActions.LIKE && actionName !== CardActions.DISLIKE) {
      iconToUpdate.url = updatedImage;
    }
    if (containerCard && containerCard.items) {
      const updatedCopilotCard = containerCard?.items?.map(
        (item: CardElement, index: number) => {
          if (item.type === AdaptiveCardType.IMAGE && index === imageIndex) {
            return { ...item, url: updatedImage };
          }
          if (actionName === CardActions.LIKE ||actionName === CardActions.DISLIKE) {
            toggleLikeDislikeHandler(item, actionName, copilotActionIcons);
          }
          
          return item;
        }
      );
      dispatch(
        updateAdaptiveCardSchema({
          updatedCopilotCard,
          caseId,
          cardId,
          containerId,
        })
      );
    }
  }
};

/**
 * Function to handle on click for container
 * @param containerCard - CardElement
 * @example
 * ```
 * toggleVisibilityJourneySummary(containerCard)
 * ```
 */
const toggleVisibilityJourneySummary = (containerCard: any) => {
  if (!containerCard || !containerCard.items) return containerCard;

  containerCard.items.forEach((item: any) => {
    if (item.isVisible !== undefined) {
      item.isVisible = !item.isVisible;
    }
    if (item.type === 'Container' && item.items !== undefined) {
      toggleVisibilityJourneySummary(item);
    }
    if (item.type === 'ColumnSet' && item.columns !== undefined) {
      item.columns.forEach((column: any) => {
        if (column.items !== undefined) {
          toggleVisibilityJourneySummary(column);
        }
      });
    }
  });
  return containerCard;
};

/**
 * Function to handle on click for container
 * @param containerCard - CardElement
 * @param cardId - number
 * @param containerId - string
 * @param caseId - string
 * @param dispatch - any
 * @example
 * ```
 * handleContainerOpen(containerCard, cardId, containerId, caseId, dispatch)
 * ```
 */
const handleContainerOpen = (
  containerCard: CardElement,
  cardId: number,
  containerId: string,
  caseId: string,
  dispatch: any
) => {
  let updatedCopilotCard: CardElement | CardElement[] = [];
  if (containerId === ContainerId.JOURNEY_SUMMARY_CONTAINER) {
    updatedCopilotCard = toggleVisibilityJourneySummary(containerCard);
  } else if (
    containerId === ContainerId.FEEDBACK_COMMENTS_CONTAINER_LIKE ||
    containerId === ContainerId.FEEDBACK_COMMENTS_CONTAINER_DISLIKE
  ) {
    updatedCopilotCard = {
      ...containerCard,
      isVisible: !containerCard.isVisible,
    };
    dispatch(
      updateAdaptiveCardSchema({
        updatedCopilotCard,
        caseId,
        cardId,
        containerId,
      })
    );
    return;
  } else if (
    containerId === ContainerId.WORKFLOW_QUESTIONS_CONTAINER ||
    containerId === ContainerId.FEEDBACK_COMMENTS_CONTAINER_LIKE ||
    containerId === ContainerId.FEEDBACK_COMMENTS_CONTAINER_DISLIKE
  ) {
    updatedCopilotCard = {
      ...containerCard,
      isVisible: !containerCard.isVisible,
    };
  } else if (containerId === ContainerId.WORKFLOW_BUTTONS_CONTAINER) {
    if (containerCard.items) {
      const columnSetButtons = containerCard.items[0].columns as CardElement[];
      const updatedcolumns = columnSetButtons.map((column: any) => {
        if (column.type === AdaptiveCardType.COLUMN && column.items) {
          if (column.isVisible !== undefined) {
            return { ...column, isVisible: !column.isVisible };
          }
        }
        return column;
      });
      const updatedColumnsSet = {
        ...containerCard.items[0],
        columns: updatedcolumns,
      };
      updatedCopilotCard = { ...containerCard, items: [updatedColumnsSet] };
    }
  } else if (containerCard.items) {
    updatedCopilotCard = containerCard.items.map((item: CardElement) => {
      if (
        item.id === ContainerId.WEB_CONTAINER ||
        item.id === ContainerId.IMAGES_CONTAINER ||
        item.id === ContainerId.PROCESS_STEPS_CONTAINER ||
        item.id === ContainerId.INTERNAL_USE_CONTAINER
      ) {
        return { ...item, isVisible: !item.isVisible };
      }
      return item;
    });
  }
  dispatch(
    updateAdaptiveCardSchema({
      updatedCopilotCard,
      caseId,
      cardId,
      containerId,
    })
  );
};

/**
 * Function to handle on click for container
 * @param containerCard - CardElement
 * @param cardId - number
 * @param containerId - string
 * @param caseId - string
 * @param dispatch - any
 * @example
 * ```
 * handleFeedbackConversationTopicsOpen(containerCard, cardId, containerId, caseId, dispatch)
 * ```
 */
const handleFeedbackConversationTopicsOpen = (
  containerCard: CardElement,
  cardId: number,
  containerId: string,
  caseId: string,
  dispatch: any,
  cardData: any,
  index: any
) => {
  let updatedCopilotCard: CardElement | CardElement[] = [];
  updatedCopilotCard = {
    ...containerCard,
    isVisible: !containerCard.isVisible,
  };
  const cardItem: CardElement = {
    ...cardData,
    items: [cardData.items[0], updatedCopilotCard],
  };
  dispatch(
    updateAdaptiveCardSchema({
      updatedCopilotCard: cardItem,
      caseId,
      cardId,
      containerId,
      feedbackIndex: index,
    })
  );
};

/**CcfCopilotActions
 * Function to get image details, file and url
 * @param imagesArray - array of CardElement
 * @param imagesIndex - number
 * @example
 * ```
 * getImageDetails(url)
 * ```
 */
const getImageDetails = async (
  imagesArray: CardElement[],
  imagesIndex: number
) => {
  const img = imagesArray[imagesIndex ?? 0] as CardElement;
  const imgUrl = `${img?.url || ''}`;
  console.log('imgUrl: ' + imgUrl);
  const imgExt = getUrlExtension(imgUrl);
  let blob;
  let file;
  if(!imgUrl.startsWith('http')){
    const response = await fetch(imgUrl);
    blob = await response.blob();
    file = new File([blob], 'image.' + imgExt, {
      type: blob.type,
    });
  }
  
  const file2 = new File([], 'image.' + imgExt, {
    type: 'image/png',
  });

  const selectedFile = imgUrl.startsWith('http') ? file2 : file;
  return { selectedFile, imgUrl };
};

/**
 * Function to get all process steps
 * @param textBlocks - array of steps
 * @param action - name of action
 * @returns - response
 * @example
 * ```
 * getProcessSteps(textBlocks, action)
 * ```
 */
const getProcessSteps = (textBlocks: string[], action: string): string => {
  let steps = '';
  for (let textId = 0; textId < textBlocks.length; textId += 2) {
    const title = textBlocks[textId];
    const description = textBlocks[textId + 1];
    const number = Math.floor(textId / 2) + 1;
    steps += `${number}. ${title} ${description} \n`;
  }
  return steps;
};

/**
 * Function to get container body by id
 * @param cardData - adaptive card schema body
 * @param id - container id
 * @returns - container body
 * @example
 * ```
 * getContainerById(cardData, id)
 * ```
 */
const getContainerById = (cardData: CardElement[], id: string): CardElement => {
  for (const container of cardData) {
    if (container.id === id && container.type === AdaptiveCardType.CONTAINER) {
      return container;
    }
  }
  return {};
};

/**
 * Function to insert response in editor
 * @param response - string to be inserted in editor
 * @param caseId - string
 * @param dispatch - any
 * @example
 * ```
 * insertTextInEditor(response, caseId, dispatch)
 * ```
 */
const insertTextInEditor = (
  response: any,
  caseId: string,
  dispatch: Dispatch<AnyAction>,
  copilotSource?: string
) => {
  dispatch(updateSentBestResponse({ response, caseId }));
  dispatch(updateIsBestResponseInserted({ isResponseInserted: true, caseId }));

  setTimeout(() => {
    dispatch(
      updateIsBestResponseInserted({ isResponseInserted: false, caseId })
    );
  }, 250);
};

/**
 * Function to send response in chat
 * @param response - string to be inserted in chat
 * @param caseId - string
 * @param dispatch - any
 * @example
 * ```
 * sendInChat(response, caseId, dispatch)
 * ```
 */
const sendInChat = (
  response: any,
  caseId: string,
  dispatch: Dispatch<AnyAction>
) => {
  dispatch(updateSentBestResponse({ response, caseId }));
  dispatch(updateIsBestResponseSent({ isResponseSent: true, caseId }));
  setTimeout(() => {
    dispatch(updateIsBestResponseSent({ isResponseSent: false, caseId }));
  }, 250);
};

export const CcfAgentCopilotContainerFunctions = {
  getImageUrl,
  getUrlExtension,
  extractDataFromCardSchema,
  extractDataFromElements,
  handleClickActions,
  handleInsertingIntentMessages,
  handleIconChange,
  handleContainerOpen,
  getImageDetails,
  getProcessSteps,
  getContainerById,
  insertTextInEditor,
  getContainerIdFromAction,
  executeCardAction,
  handleInsertOrSendData,
  handleFeedbackConversationTopicsOpen,
  mapSelectedEmailTopics,
  updateAdaptiveCardforEmail,
  extractTopicsFromAction,
  updateCardItemsforEmail,
  modifyCopilotCardTopics
};
